import React, { useContext, useEffect, useState } from "react";
import Badge from "../../../CommonComponents/Badge";
import InputDropdown from "../../../CommonComponents/InputDropdown";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Button from "../../../Button";
import Editor from "@monaco-editor/react";
import constants from "../../../../constants";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import AlertContext from "../../../../context/AlertContext";
import {
  getDataFromStorage,
  generateBoilerPlateCCode,
  generateBoilerPlateJSCode,
  generateBoilerPlateCPPCode,
  generateBoilerPlateJavaCode,
  generateBoilerPlatePythonCode,
} from "../../../../util";
import { useParams } from "react-router-dom";
import Tooltip from "../../../CommonComponents/Tooltip";
import Modal from "../../../CommonComponents/Modal";
import FeaturedIcon from "../../../CommonComponents/FeaturedIcon";

const QuestionValidation = ({
  selectedLanguage,
  setSelectedLanguage,
  languages,
  setLanguages,
  validationRules = [],
  setValidationRules,
  onChange,
  errors,
  setErrors,
  testDetails,
  setTestDetails,
  selectedCodingLanguages,
  setSelectedCodingLanguages,
  languagesOfPassedTestCases,
  setLanguagesOfPassedTestCases,
  languageKeys,
  parameters,
  dataIsLoading,
  setDataIsLoading,
}) => {
  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const Alert = useContext(AlertContext);
  const { questionid } = useParams();

  const [dataType, setDataType] = useState(
    testDetails?.functionparams.map((ip) => ip.parametertype),
  );

  const [outputDetails, setOutputDetails] = useState([]);
  const [showOutputForm, setShowOutputForm] = useState(false);
  const [value, setValue] = useState(0);
  useEffect(() => {
    //always show the first language..
    setSelectedLanguage(0);
  }, []);

  useEffect(() => {
    const fetchEvalRule = async () => {
      try {
        const response = await axios.get(
          "node/admin/evalrules/get",
          useCommonFunctionHks.getHeaderDetailsForAxios(),
        );
        console.log("respponse:", response);

        let json = response.data;
        let evalRules = json.map((rule) => {
          return {
            value: rule.id,
            label: rule.name,
          };
        });

        setValidationRules(evalRules);
      } catch (error) {
        const isUnAuth = error.message.includes("403");
        Alert.setShowNotify({
          show: true,
          msg: isUnAuth
            ? "Encountered an error while fetching coding challenge sections"
            : "You have been logged-out due to inactivity. Login again.",
          title: isUnAuth ? "Warning" : "Error",
          isUnAuth,
        });
        useCommonFunctionHks.getCatchBlockDetails(error);
      }
    };

    const fetchLanguages = async () => {
      try {
        const response = await axios.get(
          "node/admin/language/get",
          useCommonFunctionHks.getHeaderDetailsForAxios(),
        );

        let json = response.data;
        setLanguages(json);
      } catch (error) {
        const isUnAuth = error.message.includes("403");
        Alert.setShowNotify({
          show: true,
          msg: isUnAuth
            ? "Encountered an error while fetching coding challenge sections"
            : "You have been logged-out due to inactivity. Login again.",
          title: isUnAuth ? "Warning" : "Error",
          isUnAuth,
        });
        useCommonFunctionHks.getCatchBlockDetails(error);
      }
    };
    fetchEvalRule();
    fetchLanguages();
  }, []);

  // console.log("validationRUles:", validationRules);

  //       let lData = {};

  //       for (let i = 0; i < newLang.length; i++) {
  //         lData[newLang[i].label] = {
  //           solutionCode: "",
  //           executionCode: "",
  //           boilerplateCode: "",
  //           languageId: newLang[i].value,
  //         };
  //       }

  //       setMasterData(lData);
  //       setLanguageData(newLang);
  //     })

  //       let rules;

  //       if (Alert.isqueReport) {
  //         rules = Props.selectque.cc.evalrules.split(",");

  //         let presentRules = [];

  //         for (let i = 0; i < rules.length; i++) {
  //           for (let j = 0; j < evalRules.length; j++) {
  //             if (Object.values(evalRules[j]).includes(parseInt(rules[i]))) {
  //               presentRules.push(evalRules[j]);
  //             }
  //           }
  //         }

  //         setEvalRule(presentRules);
  //       }
  //     })

  // console.log("languages:", languages);

  const enableTestandSaveButton = (languageName, type, selectedlist) => {
    let languageList = languagesOfPassedTestCases;

    if (type === "remove") {
      if (languageList.indexOf(languageName) >= 0) {
        languageList.splice(languageList.indexOf(languageName), 1);
      }
    }

    if (type === "add") {
      if (languageList.indexOf(languageName) < 0) {
        languageList.push(languageName);
      }
    }
    // {1:java}
    let langLabel = selectedCodingLanguages.filter(
      (lan) => lan.name === languageName,
    );
    let langLabelArr = langLabel.map((lan) => lan.name);

    if (questionid) {
      langLabelArr = languages
        .filter((lang) =>
          languageKeys.some((apiLang) => apiLang.name === lang.name),
        )
        .map((lang) => lang.name);
    }

    if (langLabelArr.length > 0 && languageList.length > 0) {
      // setEnableSaveButton(true);
    }

    setLanguagesOfPassedTestCases(languageList);
  };

  const handleSubmit = async (data, languageName, languageid) => {
    try {
      console.log("data", data);

      let questionsData;
      // let EvalRules = testDetails?.evaluationrule
      //   .map((rule) => rule.value)
      //   .join(", ");
      let EvalRules = testDetails?.evaluationrule?.join(", ");
      console.log("data as true", EvalRules, testDetails.evaluationrule);
      let role = getDataFromStorage("role");
      console.log("ROLE BEFORE PAYLOAD:", role);
      setDataIsLoading(true);
      console.log("role from storage:", role);
      questionsData = {
        testCases: testDetails?.testcases,
        evalrules: EvalRules,
        dataTypes: dataType,
        language: languageName,
        learnerid: getDataFromStorage("learnerid"),
        // type: isNoTestCases ? "runcode" : "testcode",
        type: "testcode",
        solutionCode: data.solution,
        boilerplateCode: data.boilerplate,
        questionid: questionid,
        templateVersion: 2,
        // executionCode: data1[languageName].executionCode,
        returntype: testDetails?.returntype.value,
      };
      console.log("QUESTIONS DATA:", questionsData);
      const response = await axios.post("node/learner/code/test", questionsData);
      if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        // let parseData;

        // if (typeof response.data.result === "string") {
        //   console.log("string condition");
        //   parseData = JSON.parse(response.data.result);
        // } else {
        //   parseData = response.data.result;
        // }

        if (parseInt(response.data.resultCode) === constants.RESULT_STATUS.SUCCESS) {
          setShowOutputForm(true);
          setOutputDetails(response.data);
          enableTestandSaveButton(languageName, "add");
          // Alert.setShowNotify({
          //   show: true,
          //   msg: parseData.message,
          //   title: "Success !",
          // });
          setSelectedCodingLanguages((prev) =>
            prev.map((td) =>
              td.name === languageName ? { ...td, passed: true } : td,
            ),
          );
          setErrors((prev) => ({
            ...prev,
            2: {
              ...prev[2],
              solutionCode: "",
            },
          }));

        } else {
          setShowOutputForm(true);
          setOutputDetails(response.data);
          enableTestandSaveButton(languageName, "remove");
          // Alert.setShowNotify({
          //   show: true,
          //   msg: parseData.message,
          //   title: "Error !",
          // });
          setSelectedCodingLanguages((prev) =>
            prev.map((td) =>
              td.name === languageName ? { ...td, passed: false } : td,
            ),
          );
        }
        setDataIsLoading(false);
      }
      else if (response.data.resultCode === constants.RESULT_STATUS.TESTCASES_FAILED || response.data.resultCode === constants.RESULT_STATUS.ALL_TESTCASES_FAILED || response.data.resultCode === constants.RESULT_STATUS.PARTIAL_TESTCASES_FAILED) {
        setShowOutputForm(true);
        setOutputDetails(response.data);
        enableTestandSaveButton(languageName, "remove");
        // Alert.setShowNotify({
        //   show: true,
        //   msg: parseData.message,
        //   title: "Error !",
        // });
        setSelectedCodingLanguages((prev) =>
          prev.map((td) =>
            td.name === languageName ? { ...td, passed: false } : td,
          ),
        );
        setDataIsLoading(false);
      }
      else {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      setDataIsLoading(false);
      useCommonFunctionHks.getCatchBlockDetails(error);
      // if (error.message.includes("403")) {
      //   Alert.setShow(true);
      //   Alert.setIsUnAuth(true);
      //   Alert.setTitle("Error");
      //   Alert.setMsg(
      //     "You have been logged-out due to inactivity. Login again.",
      //   );
      // }
    }
  }
  const onChangeField = (step, field, value) => {
    onChange && onChange(step, field, value);
  };

  const handleTabChange = (event, newValue) => {
    for (let i = 0; i < selectedCodingLanguages.length; i++) {
      if (
        selectedCodingLanguages[i].id === selectedCodingLanguages[newValue].id
      ) {
        selectedCodingLanguages[i].isActive = true;
      } else {
        selectedCodingLanguages[i].isActive = false;
      }
    }
    setSelectedLanguage(newValue);
  };

  // useEffect(() => {
  //   console.log("testDetails:", testDetails);
  // }, [testDetails]);

  // useEffect(() => {
  //   console.log("selectedCodingLanguages:", selectedCodingLanguages);
  // }, [selectedCodingLanguages]);

  // useEffect(() => {
  //   console.log("error:", errors);
  // }, [errors]);
  // console.log("selected:", selectedLanguage);

  const addSelectedCodingChallenge = (language) => {
    console.log("selectedCodingLanguages:", selectedCodingLanguages);
    console.log("selected:", selectedLanguage);

    const isAlreadyThere = selectedCodingLanguages.find(
      (item) => item.id === language.id,
    );
    if (isAlreadyThere) {
      let newSelected = selectedCodingLanguages
        .filter((item) => item.id !== language.id)
        .sort((a, b) => a.id - b.id);
      setSelectedCodingLanguages(newSelected);
      setTestDetails((prev) => ({
        ...prev,
        supportedLanguage: prev.supportedLanguage.filter(
          (lang) => lang.id !== language.id,
        ),
      }));
      setSelectedLanguage((prev) => (prev === 0 ? prev : prev - 1));
    } else {
      const newObj = {
        id: language.id,
        name: language.name,
        isActive: false,
        allTestCasesPassed: false,
        boilerplate: "",
        solution: "",
        executionCode: ""
      };
      let selected = [...selectedCodingLanguages, newObj].sort(
        (a, b) => a.id - b.id,
      );
      console.log("selected:", selected, selectedCodingLanguages.length);
      setSelectedLanguage(selectedCodingLanguages.length);

      setSelectedCodingLanguages(selected);
      setTestDetails((prev) => ({
        ...prev,
        supportedLanguage: [...prev.supportedLanguage, newObj],
      }));
    }
  };

  const handleGenerateBoilerPlate = (e) => {
    const langInputLen = testDetails?.functionparams.length; // parameters

    let columns;
    let data_type; //type
    let input_variable_name; //name

    if (langInputLen > 0) {
      data_type = testDetails?.functionparams.map((ip) => ip.parametertype);
      input_variable_name = testDetails?.functionparams.map(
        (ip) => ip.parametername,
      );
      // columns = testDetails?.functionparams.map((ip) => ip.col);
    } else {
      data_type = testDetails?.functionparams.map((ip) => ip.parametertype);
      input_variable_name = testDetails?.functionparams.map(
        (ip) => ip.parametername,
      );
      // columns = inputDataSource.map((ip) => parseInt(ip.col));
    }
    const boilerplateFunction = {
      1: generateBoilerPlateJavaCode,
      2: generateBoilerPlateJSCode,
      3: generateBoilerPlateCCode,
      4: generateBoilerPlateCPPCode,
      5: generateBoilerPlatePythonCode,
    };
    // console.log("testDetails.functionParams:", testDetails.functionparams);
    // console.log("dataType:", data_type);
    // console.log("input_variable_name:", input_variable_name);

    const copyTestDetails = structuredClone(testDetails);
    let selectedLang = selectedCodingLanguages.map((lang) => lang.id);
    for (const supLang of copyTestDetails.supportedLanguage) {
      if (selectedLang.includes(supLang.id)) {
        if (supLang.solution.trim().length !== 0) {
          // console.log("supLang,", supLang);
          // console.log(
          //   "testDetails?.functionname,data_type,input_variable_name,columns,testDetails?.returntype,supLan.id",
          //   testDetails?.functionname,
          //   data_type,
          //   input_variable_name,
          //   columns,
          //   testDetails?.returntype,
          //   supLang.id,
          // );
          let { boilerplate, solutionTemplate } = boilerplateFunction[supLang.id](
            testDetails?.functionname,
            [...data_type],
            input_variable_name,
            columns,
            testDetails?.returntype,
          );
          supLang.boilerplate = boilerplate;
          supLang.executionCode = solutionTemplate;
          continue;
        } else {
          // console.log("supLang,", supLang);
          // console.log(
          //   "testDetails?.functionname,data_type,input_variable_name,columns,testDetails?.returntype,supLan.id",
          //   testDetails?.functionname,
          //   data_type,
          //   input_variable_name,
          //   columns,
          //   testDetails?.returntype,
          //   supLang.id,
          // );
          let { boilerplate, solutionTemplate } = boilerplateFunction[supLang.id](
            testDetails?.functionname,
            [...data_type],
            input_variable_name,
            columns,
            testDetails?.returntype,
          );
          supLang.boilerplate = boilerplate;
          supLang.executionCode = solutionTemplate;
        }
      }
    }
    setSelectedCodingLanguages(copyTestDetails.supportedLanguage);
    setTestDetails(copyTestDetails);
    // setBplateCode(BoilerPlateCode);
  };

  const getOptionsWithDisabled = (selectedValues) => {
    return (validationRules || []).map((option) => {
      let disabled = false;

      // If options 1 or 2 are selected, disable options 3 to 8
      if (selectedValues.includes(1) || selectedValues.includes(2)) {
        disabled = option.value >= 3 && option.value <= 8;
      }

      // If an option between 3 and 8 is selected, disable all other options
      if (selectedValues.some((value) => value >= 3 && value <= 8)) {
        disabled =
          option.value !== selectedValues.find((v) => v >= 3 && v <= 8);
      }

      return { ...option, disabled };
    });
  };

  console.log("outputDetails:", outputDetails);


  const handleModalTabChange = (event, newValue) => {
    // for (let i = 0; i < testcases.length; i++) {
    //   if (testcases[i].id === testcases[newValue].id) {
    //     testcases[i].isActive = true;
    //   } else {
    //     testcases[i].isActive = false;
    //   }
    // }
    setValue(newValue);
  };
  console.log("languages", languages, "selectedCodingLanguages", selectedCodingLanguages);

  return (
    <div className="question-validation-main-container">
      <section className="question-validation-section-1">
        <div className="question-section-1-header">
          <div className="question-section-1-header-title">
            Supported Languages*
          </div>
          <Tooltip title="Select the programming language required to solve this problem">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.66667 10.3333V7.66667M7.66667 5H7.67333M14.3333 7.66667C14.3333 11.3486 11.3486 14.3333 7.66667 14.3333C3.98477 14.3333 1 11.3486 1 7.66667C1 3.98477 3.98477 1 7.66667 1C11.3486 1 14.3333 3.98477 14.3333 7.66667Z"
                stroke="#667085"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Tooltip>
        </div>
        <div className="question-section-1-badge-container">
          {languages.length >= 1 &&
            languages.map((language) => (
              <Badge
                label={language.name}
                icon={{
                  icon: (
                    <svg
                      width="10"
                      height="7"
                      viewBox="0 0 10 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.75 0.75L3.25 6.25L0.75 3.75"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ),
                  position: "end",
                }}
                className={
                  selectedCodingLanguages.some(
                    (item) => item.id === language.id,
                  )
                    ? "selected"
                    : "notselected"
                }
                onClick={() => addSelectedCodingChallenge(language)}
              />
            ))}
        </div>
        <div className="question-section-1-info">
          Multiple languages can be selected
        </div>
      </section>

      {selectedCodingLanguages.length >= 1 && (
        <section className="question-validation-section-2">
          <div className="question-section-2-title">
            Supported Languages selected:
          </div>
          <div className="question-section-2-code-container">
            <div className="question-section-2-code-header">
              <Box
                sx={{
                  overflowX: "auto",
                  bgcolor: "background.paper",
                  maxWidth: { xs: 320, sm: 900 },
                }}
              >
                <Tabs
                  variant="scrollable"
                  scrollButtons={false}
                  value={selectedLanguage}
                  onChange={handleTabChange}
                  className="question-section-2-code-all-languages"
                  TabIndicatorProps={{ style: { display: "none" } }}
                >
                  {selectedCodingLanguages.map((tab, index) => (
                    <Tab
                      key={index}
                      label={`${tab.name}`}
                      className={`${selectedLanguage === index
                        ? "coding-active"
                        : "coding-notactive"
                        }`}
                    />
                  ))}
                </Tabs>
              </Box>
              <div style={{ marginRight: "20px", alignContent: "center" }}>
                <Button
                  size="sm"
                  onClick={(e) => {
                    handleGenerateBoilerPlate(e);
                  }}
                  hierarchy={{
                    type: "secondaryGrey",
                    buttonText: "Generate Boilerplate",
                  }}
                />
              </div>
            </div>
            <div className="question-section-2-code-content">
              {selectedCodingLanguages.map((tab, index) => (
                <>
                  <div
                    className="question-section-2-code-part"
                    hidden={selectedLanguage !== index}
                  >
                    <div className="question-section-2-code-boilerplate">
                      <p className="question-section-2-boilerplate-title">
                        Boilerplate code*
                      </p>
                      <div className="question-section-2-boilerplate-code-editor">
                        <CCCreationCodingEditor
                          language={tab.name.toLowerCase()}
                          initialCode={tab.boilerplate ?? ""}
                          from="boiler"
                          tab={tab}
                          setSelectedCodingLanguages={
                            setSelectedCodingLanguages
                          }
                          setTestDetails={setTestDetails}
                          dataIsLoading={dataIsLoading}
                        />
                      </div>
                    </div>
                    <div className="question-section-2-code-solution">
                      <p className="question-section-2-solution-title">
                        Solution Template
                      </p>
                      <div className="question-section-2-solution-code-editor">
                        <CCCreationCodingEditor
                          language={tab.name.toLowerCase()}
                          initialCode={tab.executionCode ?? ""}
                          tab={tab}
                          setSelectedCodingLanguages={
                            setSelectedCodingLanguages
                          }
                          from="executionCode"
                          setTestDetails={setTestDetails}
                          // handleSubmit={handleSubmit}
                          dataIsLoading={dataIsLoading}
                        />
                      </div>
                    </div>
                    <div className="question-section-2-code-solution">
                      <p className="question-section-2-solution-title">
                        Solution Code
                      </p>
                      <div className="question-section-2-solution-code-editor">
                        <CCCreationCodingEditor
                          language={tab.name.toLowerCase()}
                          initialCode={tab.solution ?? ""}
                          tab={tab}
                          setSelectedCodingLanguages={
                            setSelectedCodingLanguages
                          }
                          setTestDetails={setTestDetails}
                          handleSubmit={handleSubmit}
                          dataIsLoading={dataIsLoading}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
          <div
            className={`${errors?.["solutionCode"]?.trim() === "" ? "no-error" : "error"
              }`}
          >
            {errors["solutionCode"] ?? ""}
          </div>
        </section>
      )}

      <section className="question-validation-section-3">
        <InputDropdown
          value={testDetails.evaluationrule ?? []}
          options={getOptionsWithDisabled(testDetails.evaluationrule ?? [])}
          label={"Evaluation Rules"}
          name="evaluationrule"
          multiple={true}
          searchable
          placeholder="Select Evaluation Rule"
          onChange={(value) => onChangeField(2, "evaluationrule", value)}
        />
        {/* <p>Evaluation Rules</p>
        <Select
          isMulti
          value={testDetails.evaluationrule ?? []}
          name="Evaluation rules"
          options={validationRules ?? []}
          placeholder="Evaluation Rules "
          isOptionDisabled={isOptionDisabled}
          onChange={(value) => onChangeField(2, "evaluationrule", value)}
          components={{ IndicatorSeparator: () => null }}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              // borderColor: enableSaveButton ? "green" : "red",
            }),
            menuList: (base) => ({
              ...base,
              textAlign: "left",
              maxHeight: "150px",
              overflowX: "hidden",
              borderRadius: "2px",
            }),
          }}
        /> */}
      </section>

      <Modal
        centered
        showCloseIcon={true}
        isOpen={showOutputForm}
        onClose={() => {
          setShowOutputForm(false);
        }}
        title={
          <Box display="flex" alignItems="center" gap={1}>
            {outputDetails?.resultCode === constants.RESULT_STATUS.SUCCESS ? (
              <SuccesIcon />
            ) : (
              <FailureIcon />
            )}
            <span>
              {outputDetails?.resultCode === constants.RESULT_STATUS.SUCCESS
                ? outputDetails?.result.message
                : outputDetails?.resultCode ===
                  constants.RESULT_STATUS.TESTCASES_FAILED ||
                  outputDetails?.result?.resultcode ===
                  constants.RESULT_STATUS.PARTIAL_TESTCASES_FAILED
                  ? outputDetails?.result.message
                  : "Testcase Results"}
            </span>
          </Box>
        }
        closeIcon={
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="#667085"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
      >
        <div className="question-config-section-4">
          <div className="codingOutputTestcasesDivBox">
            <Box
              sx={{
                overflowX: "auto",
                bgcolor: "background.paper",
                maxWidth: { xs: 320, sm: 900 },
                display: "flex",
                gap: "16px",
              }}
            >
              <Tabs
                variant="scrollable"
                scrollButtons={false}
                value={value}
                onChange={handleModalTabChange}
                className="codingOutputTestcasesDivBoxTab"
                TabIndicatorProps={{ style: { display: "none" } }}
              >
                {outputDetails?.result?.testcases.map((tab, index) => (
                  <Tab
                    key={index}
                    label={`Test Case ${index + 1}`}
                    className={`${value === index
                      ? "codingOutputTab-active"
                      : "codingOutputTab-notactive"
                      }`}
                    icon={
                      tab?.passed ? (
                        <svg
                          width="12"
                          height="9"
                          viewBox="0 0 12 9"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.3337 0.666504L4.00033 7.99984L0.666992 4.6665"
                            stroke="#12B76A"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.33366 4.6665V7.33317M7.33366 9.99984H7.34033M14.0003 7.33317C14.0003 11.0151 11.0156 13.9998 7.33366 13.9998C3.65176 13.9998 0.666992 11.0151 0.666992 7.33317C0.666992 3.65127 3.65176 0.666504 7.33366 0.666504C11.0156 0.666504 14.0003 3.65127 14.0003 7.33317Z"
                            stroke="#F04438"
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )
                    }
                    iconPosition="end"
                  />
                ))}
              </Tabs>
            </Box>
          </div>
          <div className="testcase-parameter-container">
            {outputDetails?.result?.testcases.map((tab, index) => (
              <>
                <div className="testcase-parameters" hidden={value !== index}>
                  <div style={{ display: "flex", gap: "24px" }}>
                    <div className="testcase-parameter-expected-output">
                      <p>Expected Output</p>
                      <pre>{tab.output}</pre>
                    </div>
                    <div
                      className={
                        tab.passed
                          ? "testcase-parameter-output"
                          : "testcase-parameter-output-failed"
                      }
                    >
                      <p>Solution Code Output</p>
                      <div style={{ display: "flex", gap: "6px", maxHeight: "200px", maxWidth: "400px", overflowY: "scroll" }}>
                        <pre>{tab.actualoutput}</pre>
                        {tab.passed ? null : (
                          <div>
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 15 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.33366 4.6665V7.33317M7.33366 9.99984H7.34033M14.0003 7.33317C14.0003 11.0151 11.0156 13.9998 7.33366 13.9998C3.65176 13.9998 0.666992 11.0151 0.666992 7.33317C0.666992 3.65127 3.65176 0.666504 7.33366 0.666504C11.0156 0.666504 14.0003 3.65127 14.0003 7.33317Z"
                                stroke="#F04438"
                                strokeWidth="1.33333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="parameters">
                    <p>Values</p>
                    <div style={{ display: "flex", gap: "24px" }}>
                      {parameters.map((input, ind) => (
                        <div className="testcase-parameter-value">
                          <p>{`${input.parametername}`}</p>
                          <p>{tab?.input.split("\n")?.[ind] ?? ""}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* {tab.isExample && <div>Enabled as Example</div>} */}
              </>
            ))}
          </div>
        </div>
      </Modal>
    </div>
  );
};

const CCCreationCodingEditor = ({
  language,
  initialCode = "",
  from,
  tab,
  setSelectedCodingLanguages,
  setTestDetails,
  handleSubmit,
  dataIsLoading,
}) => {
  const [code, setCode] = useState("");

  // console.log("dataisLoading:", dataIsLoading);

  useEffect(() => {
    setCode(initialCode ?? "");
  }, [initialCode]);
  const handleEditorChange = (value, event) => {
    if (from === "boiler") {
      setCode(value);
      setSelectedCodingLanguages((prev) =>
        prev.map((lang) =>
          lang.id === tab.id ? { ...lang, boilerplate: value } : lang,
        ),
      );
      setTestDetails((prev) => ({
        ...prev,
        supportedLanguage: prev.supportedLanguage.map((lang) =>
          lang.id === tab.id ? { ...lang, boilerplate: value } : lang,
        ),
      }));
    } else if (from === "executionCode") {
      setCode(value);
      setSelectedCodingLanguages((prev) =>
        prev.map((lang) =>
          lang.id === tab.id ? { ...lang, executionCode: value } : lang,
        ),
      );
      setTestDetails((prev) => ({
        ...prev,
        supportedLanguage: prev.supportedLanguage.map((lang) =>
          lang.id === tab.id ? { ...lang, executionCode: value } : lang,
        ),
      }));
    } else {
      setCode(value);
      setSelectedCodingLanguages((prev) =>
        prev.map((lang) =>
          lang.id === tab.id ? { ...lang, solution: value } : lang,
        ),
      );
      setTestDetails((prev) => ({
        ...prev,
        supportedLanguage: prev.supportedLanguage.map((lang) =>
          lang.id === tab.id ? { ...lang, solution: value } : lang,
        ),
      }));
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <Editor
        height="400px"
        value={code}
        language={language?.toLowerCase()}
        theme={"vs-light"}
        onChange={handleEditorChange}
        options={{
          fontSize: 16,
          lineNumbers: "on",
          minimap: { enabled: false }, // Usually disabled for small code snippets
          // scrollBeyondLastLine: false,
          automaticLayout: true,
          wordWrap: "on",
          rulers: [],
          // scrollbar: {
          //   vertical: "hidden",
          //   handleMouseWheel: true, // Allows scrolling with mouse even if bar is hidden
          // },
        }}
      />
      {from !== "boiler" && from !== "executionCode" && (
        <div style={{ position: "absolute", right: "22px", bottom: "15px" }}>
          {tab?.solution && !tab?.solution?.trim() ? (
            <Button
              size="sm"
              onClick={() => {
                handleSubmit?.(tab, tab.name, tab.id);
              }}
              hierarchy={{
                type: "secondaryGrey",
                buttonText: dataIsLoading ? "Testing" : "Test",
              }}
              icon={{
                type: "leading",
                icon: (
                  <svg
                    width="14"
                    height="17"
                    viewBox="0 0 14 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.834961 0.834961L12.5016 8.33496L0.834961 15.835V0.834961Z"
                      stroke="#344054"
                      strokeWidth="1.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ),
              }}
              disable={true}
            />
          ) : (
            <Button
              size="sm"
              onClick={() => {
                handleSubmit?.(tab, tab.name, tab.id);
              }}
              hierarchy={{
                type: "primary",
                buttonText: dataIsLoading ? "Testing" : "Test",
              }}
              icon={{
                type: "leading",
                icon: (
                  <svg
                    width="14"
                    height="17"
                    viewBox="0 0 14 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.834961 0.834961L12.5016 8.33496L0.834961 15.835V0.834961Z"
                      stroke="#FFFFFF"
                      strokeWidth="1.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ),
              }}
              disable={!tab?.solution?.trim() || dataIsLoading}
            />
          )}
        </div>
      )}
    </div>
  );
};

const SuccesIcon = () => (
  <FeaturedIcon
    size="lg"
    color="succes"
    them="lightCircleOutline"
    icon={
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 11.0799V11.9999C21.9988 14.1563 21.3005 16.2545 20.0093 17.9817C18.7182 19.7088 16.9033 20.9723 14.8354 21.5838C12.7674 22.1952 10.5573 22.1218 8.53447 21.3744C6.51168 20.6271 4.78465 19.246 3.61096 17.4369C2.43727 15.6279 1.87979 13.4879 2.02168 11.3362C2.16356 9.18443 2.99721 7.13619 4.39828 5.49694C5.79935 3.85768 7.69279 2.71525 9.79619 2.24001C11.8996 1.76477 14.1003 1.9822 16.07 2.85986M22 3.99986L12 14.0099L9.00001 11.0099"
          stroke="#039855"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    }
  />
);

const FailureIcon = () => (
  <FeaturedIcon
    color="warning"
    size="lg"
    theme="lightCircleOutline"
    icon={
      <svg
        width="23"
        height="21"
        viewBox="0 0 23 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.448 7.10274V11.1027M11.448 15.1027H11.458M9.73802 1.96274L1.26802 16.1027C1.09339 16.4052 1.00099 16.748 1.00001 17.0973C0.99903 17.4465 1.08951 17.7899 1.26245 18.0933C1.43538 18.3967 1.68474 18.6495 1.98573 18.8266C2.28671 19.0037 2.62882 19.0989 2.97802 19.1027H19.918C20.2672 19.0989 20.6093 19.0037 20.9103 18.8266C21.2113 18.6495 21.4607 18.3967 21.6336 18.0933C21.8065 17.7899 21.897 17.4465 21.896 17.0973C21.8951 16.748 21.8027 16.4052 21.628 16.1027L13.158 1.96274C12.9797 1.66885 12.7287 1.42586 12.4292 1.25723C12.1297 1.08859 11.7918 1 11.448 1C11.1043 1 10.7663 1.08859 10.4668 1.25723C10.1673 1.42586 9.91629 1.66885 9.73802 1.96274Z"
          stroke="#DC6803"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    }
  />
);

export default QuestionValidation;
